const constants = {
  /* FRONTEND VARIABLES */
  BorderRadius: {
    sm: `2px`,
    nm: `4px`,
    lg: `8px`,
    no: `0`,
    singleSm: `2px`,
    singleNm: `4px`,
    singleLg: `8px`,
    singleNo: `0`,
  },
  Breakpoints: { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 },
  Effect: {
    transitionBasic: `all 0.2s ease`,
    transitionImage: `all 0.6s ease`,
    boxShadowInput: `0 0 0 0.2rem rgb(213 96 143 / 25%)`,
  },
  Icon: {
    xt: 8,
    tn: 10,
    xs: 12,
    sm: 14,
    nm: 16,
    xn: 18,
    md: 20,
    xm: 22,
    lg: 24,
    xl: 32,
    hg: 40,
    xh: 48,
    xx: 64,
  },
  Layout: {
    containerXl: `90%`,
    gutterHalf: `15px`,
    gutter: `30px`,
    gutterDouble: `60px`,
  },
  MediaQueries: {
    phone: `only screen and (max-width:767px)`,
    tablet: `only screen and (min-width:768px) and (max-width:991px)`,
    gteTablet: `only screen and (min-width:768px)`,
    lteTablet: `only screen and (max-width:991px)`,
    desktop: `only screen and (min-width:992px) and (max-width:1199px)`,
    gteDesktop: `only screen and (min-width:992px)`,
    gteDesktopLg: `only screen and (min-width:1200px)`,
  },
  Modal: { sm: `340px`, nm: `500px`, lg: `800px`, xl: `1140px` },
  Size: {
    xt: `2px`,
    tn: `3px`,
    xs: `5px`,
    sm: `7px`,
    nm: `10px`,
    xn: `15px`,
    md: `20px`,
    xm: `25px`,
    lg: `30px`,
    xl: `40px`,
    hg: `50px`,
    xh: `60px`,
    xx: `80px`,
  },
  Theme: {
    _default: `#7c7e91`,
    primary: `#d5608f`,
    secondary: `#343645`,
    white: `#ffffff`,
    greyLight: `#d6cccb`,
    greyLightOpacity: `#f6f2f1`,
    greyLighter: `#f0ebe8`,
    transparent: `rgba(255,255,255,0)`,
    primaryActive: `#a3496d`,
    secondaryActive: `#343645`,
    facebook: `#4267B2`,
    google: `#EA4335`,
    defaultActive: `#676978`,
    success: `#4FE3AD`,
    successActive: `#47C999`,
    warning: `#FAD957`,
    warningActive: `#E0C34F`,
    danger: `#FF8480`,
    dangerActive: `#E67773`,
    info: `#ffcd76`,
    infoActive: `#ffe669`,
    // info: `#8CECFF`,
    // infoActive: `#7ED4E6`,
  },
  Type: {
    h1Size: `42px`,
    h2Size: `28px`,
    h3Size: `22px`,
    h4Size: `18px`,
    h5Size: `16px`,
    h6Size: `14px`,
    xt: `10px`,
    tn: `11px`,
    xs: `12px`,
    sm: `13px`,
    nm: `14px`,
    xn: `16px`,
    md: `18px`,
    xm: `22px`,
    lg: `28px`,
    xl: `36px`,
    hg: `42px`,
    xh: `56px`,
    xx: `64px`,
    light: `silkalight`,
    regular: `silkaregular`,
    medium: `silkamedium`,
    semibold: `silkasemibold`,
    bold: `silkabold`,
  },
  ZIndex: {
    bg: 0 - 1,
    base: 0,
    min: 1,
    first: 100,
    element: 500,
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
    preloader: 1100,
  },
  /* ENVIROMENT VARIABLES */
  CookiesOptions: {
    maxAge: 7 * 24 * 60 * 60,
    path: `/`,
  },
  Dates: {
    numeric: { year: "numeric", month: `numeric`, day: `numeric` },
  },
  Locale: { cs: `cs-CZ`, sk: `sk-SK`, en: `en-UK` },
  Locales: {
    cs: {
      lang: `cs`,
      language: `czech`,
      territory: `cz`,
      locale: `cs-CZ`,
      country: `Czech Republic`,
    },
    sk: {
      lang: `sk`,
      language: `slovak`,
      territory: `sk`,
      locale: `cs-SK`,
      country: `Slovakia`,
    },
    en: {
      lang: `en`,
      language: `english`,
      territory: `gb`,
      locale: `en-UK`, //TODO: correct iso en-GB
      country: `England`,
    },
    _default: {
      lang: `cs`,
      language: `czech`,
      territory: `cz`,
      locale: `cs-CZ`,
      country: `Czech Republic`,
    },
    _static: [{ lang: `cs` }, { lang: `sk` }, { lang: `en` }],

    // NEEDED FOR NEXT.JS. It needs to have "global" language, to be able to generate static pages without locale prefix.
    default: {
      lang: `cs`,
      language: `czech`,
      territory: `cz`,
      locale: `cs-CZ`,
      country: `Czech Republic`,
    },
  },
  Paths: {
    apiUrl:
      process.env.NODE_ENV === `development`
        ? process.env.NEXT_PUBLIC_BACKEND_URL
          ? process.env.NEXT_PUBLIC_BACKEND_URL
          : `http://localhost:1337`
        : `https://api.anandita.cz`,
    appUrl:
      process.env.NODE_ENV === `development`
        ? `http://localhost:3333`
        : process.env.VERCEL_URL
        ? `https://` + process.env.VERCEL_URL
        : `https://app.anandita.cz`,
    imagesUrl: "",
    providerYoutube: `https://www.youtube.com/`,
    providerYoutubeChannel: `https://www.youtube.com/channel/`,
    providerVimeo: `https://www.vimeo.com/`,
    providerVimeoChannel: `https://www.vimeo.com/`,
    providerInstagram: `https://www.instagram.com/`,
    providerInstagramApi: `https://api.instacloud.io`,
    questionnaireYogis: `https://s.surveyplanet.com/5iCcVu0Lk`,
    questionnaireInstructors: `https://s.surveyplanet.com/cV3S8S3zQ`,
    registerInstructor: `/register-instructor`,
    defaultInstructorSlug: `barbora-hu`,
    defaultLectureSlug: `slunce-a-mesic`,
    defaultProgramSlug: `v-souladu`,
    publicTransferCS: `https://www.uschovna.cz/`,
    publicTransferSK: `http://www.sp-servis.sk/`,
    publicTransferEN: `https://www.wetransfer.com/`,
    profileEmailCS: `profil@anandita.life`,
    profileEmailSK: `profil@anandita.life`,
    profileEmailEN: `profile@anandita.life`,
    profileDocumentCS: `https://www.anandita.life/docs/anandita_profil_manual.docx`,
    partnerParam: `?partner=anandita`,
  },
  RefreshIntervals: {
    default: 10 * 60 * 1000,
  },
  PriceCoeficient: {
    default: 1,
  },
  /* CONTENT VARIABLES */
  Filter: {
    ShowRating: false,
    ShowDuration: false,
    SkillCategories: [`being`, `body`, `mind`, `soul`, `vitality`],
  },
  Images: {
    profilePhotoWidthDesktop: 200,
    profilePhotoWidthTablet: 180,
    profilePhotoWidthPhone: 140,
    profilePhotoRowWidth: 200,
    profilePhotoBottomIntend: 20,
    profilePhotoLeftIntend: 30,
    profilePhotoListWidth: 160,
    profilePhotoFullSize: true,
    motivePhotoHeightDesktop: 400,
    motivePhotoHeightTablet: 320,
    motivePhotoHeightPhone: 240,
    motivePhotoFullSize: true,
    galleryPhotoHeightDesktop: 165,
    galleryPhotoHeightTablet: 185,
    galleryPhotoHeightPhone: 285,
    galleryPhotoMaxHeight: 640,
    galleryPhotoMaxWidth: 960,
    avatarWidthTetablet: 40,
    avatarWidthPhone: 32,
    videophotoFullSize: false,
  },
  List: {
    hpAudios: [],
    hpClasses: [349, 315, 118, 117, 119, 285, 262, 124, 186, 126, 155, 97],
    /*
      349 – Otevírání a uzamykání
      315 - Základní pohyby
      118 - Uvolnění a protažení krku
      117 - Funkční a pevný střed
      119 - Uvolnění hrudníku a ramen
      285 - Masáž celého těla I
      262 - Den 1 - Qigong na rozproudění energie a uvolnění bloků
      124 - Pozdrav slunci A a B
      186 - Hatha jóga - čtvrtá asánová praxe
      126 - Sedové pozice
      155 - Jógové osvěžení
      97 - Jógová praxe pro klidnou mysl
    */
    hpFestivals: [22, 17, 22],
    /*
      22 - Prague spirit festival 2021
      17 - Festival jóga pro dobrou věc
     */
    hpInstructors: [121, 118, 33, 100, 1, 119, 7, 20, 6, 90, 9, 78],
    /*
      121 – Tomáš Strnad
      118 - Prague Spirit festival
      33 - Alžběta Husáková
      100 – Jana Rachno
      1 - Barbora Hu
      119 - Kristýna Veit Tesařová
      7 - Dagmar Volfová
      20 – Renata Martinová
      6 - Katka Rojková
      90 - Markéta Leblová
      9 - Magdalena Štarhová
      78 - Veronika Carmanová
    */
    hpPartners: [],
    hpSeries: [24, 5, 4, 20, 21, 6, 16, 3, 13],
    /*
      24 - Paddleboard jóga
      5 - Minikurz jógy pro zdravá záda
      4 - Dobro pro tělo a mysl
      20 - Masáže miminek pro správný psychomotorický vývoj
      21 - 3-denní minikurz: Vnitřní síla
      6 - 1. Série aštangové praxe
      16 - Dechem k srdci
      3 - Cesta k souladu
      13 - Jóga na každý den
    */
    hpStreams: [],
    limitAll: 1000,
    limitAnswers: 2,
    limitAvatars: 9,
    limitInstructors: 21,
    limitInstructorVideos: 4,
    limitPartners: 21,
    limitBenefitCardTags: 3,
    limitVideos: 60,
  },
  Show: {
    accountSign: true, // login, register, user accoung
    accountBilling: false, // user account billing informations
    accountBecomeInstructor: false, // sign contract to become instructor from client
    accountCoupons: false, // user account coupons
    accountProfile: true, // user account profile
    accountPhotos: true, // user account photos
    accountContentForSale: true, // user account content for sale
    accountPayments: false, // user account payments
    accountContract: false, // user account contract details
    homepageHero: true, // show hero banner on homepage
    homepageHeroGiftCard: false, // show btn for sending gift card
    homepageContentAudio: false, // show audio in list of content
    homepageContentStream: false, // show stream in list of content
    homepageWhyToUseCompanies: false, // show stream in list of content
    instructorContacts: true, // contact to instructors in detail and on ohter places
    instructorGallery: true, // gallery in detail of instructor
    instructorInstagram: false, // instagram gallery in detaily of instructor
    instructorLoyalty: false, // loyalty level of instructor in detail
    instructorRates: true, // rates in detail of instructor
    contentAdd: false, // possibility to add new content (mostly video)
    contentAsanas: false, // asanas in list, detail and on other places
    contentDocuments: true, // attached documents in lecture or program detail
    contentMore: true, // more content in lists (mostly video)
    contentMux: true, // mux video on detail instead of yt
    contentQuestionnaire: true, // link to questionnaire in contact modal
    contentOfflineStorage: false, // possibility to download content to offline storage
    contentSamplesInModal: false, // open sample videos in modal
    navFavorite: false, // possibility to set content as favourite
    navFilter: true, // filtration menu in lists
    navLanguages: false, // show language switcher in header
    navPublishButtons: false, // publish buttons in detail of content
    navQuickplay: false, // quick filtration modal
    navRating: false, // possibility to rate any content and show results of ratings
    navSearch: true, // search in heading
    navSocialLogin: false, // login with Google or Facebook
    navSort: true, // sortin options in list header
    pageBenefits: false, // show link to store page
    sale: true, // possibility to sell any content
    saleCartCoupons: true, // show coupons in cart
    salePaidContent: true, // info about paid content in every place
    streamCreate: true, // create new stream from profile account
  },
  Text: {
    descriptionRowsShort: 6,
    descriptionRowsLong: 8,
    descriptionCharsPerRow: 30,
  },
  Video: {
    streamFinishAfter: 5400, // after X seconds show Stream finished overlay
    sampleVideoCut: false, // custom youtube video cut after specific time
    sampleVideoLength: 15000, // sample youtube video length in miliseconds
  },
  VideoCard: {
    heightSm: `320px`,
    heightNm: `480px`,
    heightLg: `560px`,
    bodyHeightPreviewSm: `102px`,
    bodyHeightSeriesSm: `120px`,
    bodyHeightNm: `110px`,
    bodyHeightLg: `102px`,
    recommendedSeries: [
      `cyklicka-joga-pro-vedomou-zenu`,
      `minikurz-jogy-pro-zdrava-zada`,
      `dobro-pro-telo-a-mysl`,
    ],
    recommendedClasses: [
      `kratka-joga-z-karibiku-garudasana`,
      `shakti-shiva-flow`,
      `pozdrav-slunce-se-zpivanim-manter`,
    ],
  },
  /* BUSINESS AND MARKETING VARIABLES */
  Finance: {
    bankAccount: "2300192090/2010",
  },
  Marketing: {
    contribution: 500,
    unspentBonuses: 131,
    ogTitle: `Anandita - caring for your soul with yoga`,
    ogDescription: `We help yogis and instructors make their online lives easier.`,
    mailchimpSubscribeUrl: `https://anandita.us15.list-manage.com/subscribe/post?u=8a1cf09603b04d4f7bcad90c5&amp;id=a7a5e6d972`,
  },
  Social: {
    fbPageId: `248522758665038`,
    fbAppId: `692729318532586`,
    fbPixelId: `371903434800149`,
    instagramLink: "https://www.instagram.com/anandita.yoga/",
    facebookLink: "https://www.facebook.com/ananditacz/",
    youtubeLink: "https://www.youtube.com/channel/UC3mpRrTqBd0f3Eio2q6aAoQ",
  },
};

export default constants;
